let ProgramUtil = require("../util/ProgramUtil");
let ProgramChart = require("./ProgramChart");

let Table = mc.widgets.Table;
let Meter = mc.widgets.Meter;

let SubjectProgramDetail = function (props) {
  let cols = [
    {
      prop: "fromDate",
      label: tx("date"),
      content: function (stat) {
        return mc.format.date(stat.fromDate, "GMT");
      }
    },
    {
      prop: "tasksAssigned",
      label: tx("pct_tasks"),
      content: function (stat) {
        let [a, b] = [stat.tasksCompleted, stat.tasksAssigned];
        let pct = b === 0 ? 1 : a / b;
        let label = `${a}/${b} (${mc.format.percent(pct)})`;

        return (
          <div className="rc-subject-program-detail">
            <Meter width={80} height={8} percent={pct} color={mc.ui.colors.GREEN}/>
            <span>{label}</span>
          </div>
        );
      }
    }
  ];

  return (
    <div>
      <h1>{tx("program")}</h1>
      <p>{props.summary}</p>
      <Table
        data={props.complianceStats}
        rowKey="fromDate"
        cols={cols}
        sort={"fromDate"}/>
    </div>
  );
};

let SubjectProgram = function (props) {
  let { program, programStartTs, complianceStats, tz } = props;

  if (!program || !programStartTs) {
    return <div>{"N/A"}</div>;
  }

  let programInfo = ProgramUtil.info(program, programStartTs, tz);

  let completed = mc.math.sum(complianceStats, "tasksCompleted");
  let assigned = mc.math.sum(complianceStats, "tasksAssigned");
  let percent = mc.format.percent(assigned === 0 ? 1 : completed / assigned);
  let summary = tx("compliance_summary", { completed, assigned, percent });

  let expand = function () {
    mc.ui.modal(
      <SubjectProgramDetail
        complianceStats={complianceStats}
        summary={summary}/>, { maxWidth: "350px" });
  };

  return (
    <div className="rc-subject-program">
      <ProgramChart programInfo={programInfo}/>
      <div>{tx("programStatus." + programInfo.status, programInfo)}</div>
      <a onClick={expand}>
        {summary}
      </a>
    </div>
  );
};

module.exports = SubjectProgram;
